export enum HttpResponseType {
  Json = 'json',
  Text = 'text',
  Blob = 'blob',
  ArrayBuffer = 'arraybuffer',
}
